<template v-slot:tutorial>
  <transition name="fade">
    <div v-show="isActive" class="tutorial__item">
      <!--
          Close button is implemented by CSS vendor, but we decided
          not to show it for now, to force users go through the
          quesionnaire.
        a href="javascript:void(0);" class="tutorial__close"
          ><span class="iconfont iclose"></span
        ></a>-->
      <div class="tutorial__image-box">
        <img
          v-if="showNewSaveDesign"
          class="tutorial__image"
          src="@/assets.app/images/tutorial-save.svg"
          alt=""
        />
        <img
          v-else
          class="tutorial__image"
          src="@/assets.app/images/tutorial-favorite.svg"
          alt=""
        />
      </div>
      <div class="tutorial__text-box">
        <template v-if="showNewSaveDesign">
          <h5 class="tutorial__title">Save</h5>
          <p class="tutorial__text">
            Save to your Want to Read list or another reading list. You can find
            your reading lists in My Library.
          </p>
        </template>
        <template v-else>
          <h5 class="tutorial__title">Add to Favorite</h5>
          <p class="tutorial__text">
            Mark your favorite guides here. You can find your favorites on your
            homepage.
          </p>
        </template>
        <div class="tutorial__btn-box">
          <a class="tutorial__btn btns" @click="bookTutorial.incrementStep()"
            >Next<span class="tutorial__btn-arr iconfont inext"></span
          ></a>
        </div>
        <ul class="tutorial__dots">
          <li class="tutorial__dot"></li>
          <li class="tutorial__dot"></li>
          <li class="tutorial__dot"></li>
          <li class="tutorial__dot"></li>
          <li class="tutorial__dot"></li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { BookTutorial, BookTutorialStep } from '@/models/doc.tutorial'
import { saveForLater20321Treatment } from '@/services/ab/experiments'

const props = defineProps<{
  bookTutorial: BookTutorial
}>()

const isActive = computed(() => {
  return props.bookTutorial.step === BookTutorialStep.favorite
})

const showNewSaveDesign = computed(() => saveForLater20321Treatment())
</script>
